// =============================================
// CART - ADD TO CART + OPEN FLYOUT
// (custom main-product form; theme listens to apps:product-added-to-cart)
// =============================================

function getQuickCartEmptyMessage() {
  if (window.theme && theme.strings && theme.strings.cart && theme.strings.cart.general && theme.strings.cart.general.empty) {
    return theme.strings.cart.general.empty;
  }
  return "No products";
}

function showQuickCartEmptyState() {
  var itemsRoot = document.querySelector(".quick-cart__items.js-items");
  var footer = document.querySelector(".quick-cart__footer.js-footer");
  if (!itemsRoot) return;

  itemsRoot.innerHTML = '<p class="quick-cart__empty-state">' + getQuickCartEmptyMessage() + "</p>";

  if (footer) {
    footer.classList.remove("active");
  }
}

function buildQuickCartImageUrl(url) {
  if (!url) return "";

  var absolute = url.indexOf("//") === 0 ? "https:" + url : url;
  var clean = absolute.replace(/_(\d+x\d+|\d+x|x\d+)(?=\.(jpg|jpeg|gif|png|bmp|webp)(\?|$))/i, "");
  var glue = clean.indexOf("?") >= 0 ? "&" : "?";

  return clean + glue + "width=280";
}

function applyQuickCartImage(wrap, item) {
  var imageUrl = item.image || (item.featured_image && item.featured_image.url);
  if (!wrap || !imageUrl) return;

  var src = buildQuickCartImageUrl(imageUrl);
  var title = (item.product_title || "").replace(/"/g, "&quot;");
  var img = wrap.querySelector("img");

  if (img) {
    if (img.getAttribute("data-cart-src") === src) return;
    img.setAttribute("data-cart-src", src);
    img.setAttribute("data-cart-image-fixed", "true");
    img.addEventListener("error", function onError() {
      img.removeEventListener("error", onError);
      img.src = imageUrl.indexOf("//") === 0 ? "https:" + imageUrl : imageUrl;
    });
    img.src = src;
    if (!img.alt) img.alt = item.product_title || "";
    return;
  }

  wrap.innerHTML =
    '<a href="' +
    item.url +
    '"><img src="' +
    src +
    '" alt="' +
    title +
    '" loading="lazy" data-cart-image-fixed="true" data-cart-src="' +
    src +
    '"></a>';
}

function fixQuickCartImages() {
  fetch("/cart.js", { credentials: "same-origin" })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (!cart.items || !cart.items.length) return;

      var rows = document.querySelectorAll('.cart__item[data-component="quickCartItem"]');

      cart.items.forEach(function (item, index) {
        var el =
          document.querySelector('.cart__item[data-id="' + item.variant_id + '"]') ||
          rows[index];
        if (!el) return;

        applyQuickCartImage(el.querySelector(".quick-cart__image"), item);
      });
    })
    .catch(function () {});
}

function watchQuickCartImages() {
  var itemsRoot = document.querySelector(".quick-cart__items.js-items");
  if (!itemsRoot || itemsRoot.getAttribute("data-cart-image-watch") === "true") return;

  itemsRoot.setAttribute("data-cart-image-watch", "true");
  new MutationObserver(function () {
    fixQuickCartImages();
  }).observe(itemsRoot, { childList: true, subtree: true });
}

function refreshQuickCartUI() {
  var itemsRoot = document.querySelector(".quick-cart__items.js-items");
  if (itemsRoot && !itemsRoot.querySelector(".cart__item") && !itemsRoot.querySelector(".quick-cart__empty-state")) {
    showQuickCartEmptyState();
    return;
  }

  addRemoveButtons();
  fixQuantity();
  addCheckoutButton();
  fixQuickCartImages();
}

function handleProductFormSubmit(e) {
  var form = e.target.closest("form[data-product-form][data-ajax-enabled='true']");
  if (!form || !form.classList.contains("pd-form")) return;

  e.preventDefault();

  var button = form.querySelector("[data-add-to-cart], .pd-btn-add, [type='submit']");
  if (button) button.classList.add("bttn--loading");

  fetch("/cart/add.js", {
    method: "POST",
    credentials: "same-origin",
    body: new FormData(form)
  })
    .then(function (r) { return r.json(); })
    .then(function (item) {
      if (item.status === 422) {
        throw new Error(item.description || item.message || "Could not add to cart");
      }
      // Triggers theme cartDrawer open + refresh (see theme.js header init)
      document.dispatchEvent(new Event("apps:product-added-to-cart"));
    })
    .catch(function (err) {
      console.error("Add to cart failed:", err);
    })
    .finally(function () {
      if (button) button.classList.remove("bttn--loading");
    });
}

document.addEventListener("submit", handleProductFormSubmit);

document.addEventListener("flu:quick-cart:open", function () {
  watchQuickCartImages();
  refreshQuickCartUI();
  setTimeout(fixQuickCartImages, 50);
  setTimeout(fixQuickCartImages, 250);
});

document.addEventListener("apps:product-added-to-cart", function () {
  watchQuickCartImages();
  setTimeout(fixQuickCartImages, 50);
  setTimeout(fixQuickCartImages, 250);
});

document.addEventListener("flu:cart:updated", function (evt) {
  var cart = evt.detail && evt.detail.cart;
  if (cart) {
    var countEl = document.querySelector(".quick-cart__indicator-inner");
    var indicatorWrap = document.querySelector(".js-cart-count");
    if (countEl) countEl.innerHTML = cart.item_count;
    if (indicatorWrap) indicatorWrap.classList.toggle("hidden", !cart.item_count);

    if (!cart.item_count) {
      showQuickCartEmptyState();
      return;
    }
  }
  watchQuickCartImages();
  refreshQuickCartUI();
  setTimeout(fixQuickCartImages, 50);
  setTimeout(fixQuickCartImages, 250);
});

document.addEventListener("DOMContentLoaded", watchQuickCartImages);

document.addEventListener("flu:cart:error", function (evt) {
  console.error("Cart error:", evt.detail && evt.detail.errorMessage);
});

document.addEventListener("flu:product:variant-change", function (evt) {
  console.log("Product variant changed", evt.detail.variant);
});

document.addEventListener("flu:product:quantity-update", function (evt) {
  console.log("Product quantity updated", evt.detail.quantity, evt.detail.variant);
});

document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// =============================================
// TRANSPARANTE HEADER
// =============================================

(function () {
  function handleHeaderScroll() {
    var header = document.querySelector(".header-section");
    if (!header) return;
    if (window.scrollY > 10) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    handleHeaderScroll();
    window.addEventListener("scroll", handleHeaderScroll, { passive: true });
  });

  if (document.readyState === "complete" || document.readyState === "interactive") {
    handleHeaderScroll();
    window.addEventListener("scroll", handleHeaderScroll, { passive: true });
  }
})();

// =============================================
// HAMBURGER MENU - VOORKOMT PAGINASPRONG
// =============================================

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest("#mobile-nav, .drawer-menu__close, [data-close-drawer]");
    if (trigger) e.preventDefault();
  });
});

// =============================================
// FILTER BUTTON
// =============================================

function addFilterButton() {
  const mainArea = document.querySelector(".collection__main-area");
  if (!mainArea || document.querySelector(".custom-filter-btn-wrapper")) return;
  const wrapper = document.createElement("div");
  wrapper.classList.add("custom-filter-btn-wrapper");
  const btn = document.createElement("button");
  btn.classList.add("custom-filter-btn");
  btn.textContent = "Filter +";
  btn.addEventListener("click", function () {
    const firstTrigger = document.querySelector("[data-filter-open]");
    if (firstTrigger) firstTrigger.click();
  });
  wrapper.appendChild(btn);
  const filterContainer = document.querySelector("[data-filter-buttons-container]");
  if (filterContainer) {
    filterContainer.parentNode.insertBefore(wrapper, filterContainer);
  } else {
    mainArea.insertBefore(wrapper, mainArea.firstChild);
  }
}

// =============================================
// REMOVE BUTTONS IN CART
// =============================================

function addRemoveButtons() {
  document.querySelectorAll(".quick-cart__item-bottom").forEach(function (bottom) {
    if (bottom.querySelector(".custom-remove-btn")) return;
    const cartItem = bottom.closest(".cart__item");
    const variantId = cartItem ? cartItem.dataset.id : null;
    if (!variantId) return;
    const btn = document.createElement("button");
    btn.className = "custom-remove-btn";
    btn.textContent = "Remove";
    btn.style.cssText = "font-size:11px;color:rgba(0,0,0,0.4);background:none;border:none;cursor:pointer;text-decoration:underline;letter-spacing:0.03em;padding:0;";
    btn.addEventListener("click", function () {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 0 })
      }).then(function () {
        document.dispatchEvent(new Event("apps:product-added-to-cart"));
      });
    });
    bottom.appendChild(btn);
  });
}

// =============================================
// FIX QUANTITY DISPLAY
// =============================================

function fixQuantity() {
  document.querySelectorAll(".quick-cart__item-total").forEach(function (el) {
    el.textContent = parseInt(el.textContent, 10);
  });
}

// =============================================
// CHECKOUT BUTTON
// =============================================

function addCheckoutButton() {
  const footer = document.querySelector(".quick-cart__footer");
  if (!footer || footer.querySelector(".custom-checkout-btn")) return;
  const btn = document.createElement("a");
  btn.className = "custom-checkout-btn bttn bttn-full";
  btn.href = "/checkout";
  btn.textContent = "Checkout";
  btn.style.cssText = "display:block;text-align:center;background:#000;color:#fff;padding:14px;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;margin-top:8px;text-decoration:none;";
  footer.appendChild(btn);
}

// =============================================
// DOM READY
// =============================================

function loadMnareAssetCss(filename, id) {
  if (document.getElementById(id)) return;

  var customLink = document.querySelector('link[href*="custom.css"]');
  if (!customLink) return;

  var link = document.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = customLink.href.replace(/custom\.css/, filename);
  document.head.appendChild(link);
}

function loadMnareFooterCss() {
  loadMnareAssetCss("mnare-footer.css", "mnare-footer-css");
}

function loadMnareHeaderCss() {
  loadMnareAssetCss("mnare-header.css", "mnare-header-css");
}

function alignShopDropdown() {
  if (window.innerWidth < 960) return;

  var shopLink = document.querySelector(".header__nav .nav__item-parent .nav__link-parent");
  var submenu = document.querySelector(".header__nav .nav--depth-2.nav__submenu");
  if (!shopLink || !submenu) return;

  var offset = Math.round(shopLink.getBoundingClientRect().left - submenu.getBoundingClientRect().left);
  if (offset > 0) {
    submenu.style.setProperty("--mnare-shop-dropdown-offset", offset + "px");
  }
}

function loadMnareContactCss() {
  loadMnareAssetCss("mnare-contact.css", "mnare-contact-css");
}

function shouldSkipContactRefresh() {
  return !!document.querySelector(
    ".contact__form .form-status__message--success, .contact__form .form-status__message--error"
  );
}

function refreshContactSection() {
  if (window.location.pathname.replace(/\/$/, "") !== "/pages/contact") return;
  if (shouldSkipContactRefresh()) return;

  loadMnareContactCss();

  var contact = document.querySelector(".contact.section");
  if (!contact) return;

  var marker = document.querySelector(".mnare-contact-marker[data-layout='v7']");
  var layoutOk = marker && contact.classList.contains("contact--centered");

  if (layoutOk) return;

  var wrapper = contact.closest(".shopify-section");
  if (!wrapper || !wrapper.id) return;

  var sectionId = wrapper.id.replace("shopify-section-", "");
  fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId), {
    credentials: "same-origin",
  })
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector(".shopify-section");
      if (!fresh) return;
      wrapper.replaceWith(fresh);
      var updated = document.querySelector(".contact.section");
      if (updated) updated.classList.add("is-visible");
    })
    .catch(function () {});
}

function showContactSection() {
  if (window.location.pathname.replace(/\/$/, "") !== "/pages/contact") return;
  var contact = document.querySelector(".contact.section");
  if (contact) contact.classList.add("is-visible");
}

// =============================================
// PRODUCT CARD - KLEURFOTO INFADEN BIJ HOVER OP SWATCH
// =============================================

var activeColorDot = null;

function getColorPreviewHost(element) {
  var card = element.closest("[data-product-card]");
  if (!card) return null;

  var primary = card.querySelector("[data-product-card-primary-image]");
  if (!primary) return null;

  return primary.parentElement;
}

function findColorPreviewLayer(host, src) {
  var layers = host.getElementsByClassName("product-item__color-preview");

  for (var i = 0; i < layers.length; i++) {
    if (layers[i].getAttribute("data-color-src") === src) return layers[i];
  }

  return null;
}

function createColorPreviewLayer(host, src) {
  var layer = document.createElement("div");
  layer.className = "product-item__color-preview";
  layer.setAttribute("data-color-src", src);

  var image = document.createElement("img");
  image.setAttribute("alt", "");
  image.setAttribute("src", src);
  layer.appendChild(image);

  host.appendChild(layer);

  return layer;
}

function hideColorPreviewLayers(host, keep) {
  var layers = host.getElementsByClassName("product-item__color-preview");

  for (var i = 0; i < layers.length; i++) {
    if (layers[i] !== keep) layers[i].classList.remove("is-visible");
  }
}

// Laadt de kleurfoto's zodra de muis de kaart raakt, zodat ook de eerste hover meteen fadet
function prepareColorPreviews(card) {
  if (card.getAttribute("data-color-previews-ready") === "true") return;
  card.setAttribute("data-color-previews-ready", "true");

  var dots = card.getElementsByClassName("product-item__color-dot");

  for (var i = 0; i < dots.length; i++) {
    var src = dots[i].getAttribute("data-color-image");
    if (!src) continue;

    var host = getColorPreviewHost(dots[i]);
    if (host && !findColorPreviewLayer(host, src)) createColorPreviewLayer(host, src);
  }
}

function revealColorPreview(host, layer) {
  hideColorPreviewLayers(host, layer);
  void layer.offsetWidth;
  layer.classList.add("is-visible");
}

function showColorPreview(dot) {
  var src = dot.getAttribute("data-color-image");
  if (!src) return;

  var host = getColorPreviewHost(dot);
  if (!host) return;

  var layer = findColorPreviewLayer(host, src) || createColorPreviewLayer(host, src);
  var img = layer.querySelector("img");

  if (img && !img.complete) {
    img.onload = function () {
      if (activeColorDot !== dot) return;
      revealColorPreview(host, layer);
    };
    return;
  }

  revealColorPreview(host, layer);
}

function hideColorPreview(element) {
  var host = getColorPreviewHost(element);
  if (host) hideColorPreviewLayers(host, null);
}

function bindColorPreviews() {
  document.addEventListener("mouseover", function (e) {
    if (!e.target.closest) return;

    var card = e.target.closest("[data-product-card]");
    if (card) prepareColorPreviews(card);

    var dot = e.target.closest(".product-item__color-dot");
    if (!dot) return;

    activeColorDot = dot;
    showColorPreview(dot);
  });

  // De kleurfoto blijft staan zolang je binnen de rij rondjes beweegt, ook in de ruimte ertussen
  document.addEventListener("mouseout", function (e) {
    if (!e.target.closest) return;

    var group = e.target.closest(".product-item__color-dots");
    if (!group) return;

    if (e.relatedTarget && group.contains(e.relatedTarget)) return;

    activeColorDot = null;
    hideColorPreview(group);
  });

  document.addEventListener("focusin", function (e) {
    var dot = e.target.closest && e.target.closest(".product-item__color-dot");
    if (!dot) return;

    activeColorDot = dot;
    showColorPreview(dot);
  });

  document.addEventListener("focusout", function (e) {
    if (!e.target.closest) return;

    var group = e.target.closest(".product-item__color-dots");
    if (!group) return;

    if (e.relatedTarget && group.contains(e.relatedTarget)) return;

    activeColorDot = null;
    hideColorPreview(group);
  });
}

document.addEventListener("DOMContentLoaded", function () {
  loadMnareFooterCss();
  loadMnareHeaderCss();
  alignShopDropdown();
  window.addEventListener("resize", alignShopDropdown);
  addRemoveButtons();
  fixQuantity();
  addCheckoutButton();
  addFilterButton();
  showContactSection();
  refreshContactSection();
  bindColorPreviews();
});

document.addEventListener("shopify:section:load", alignShopDropdown);

